import { apiClient } from "@/courses/services/GenericService.js";
import {
  apiClient as apiClientV2,
  formDataAPIClient,
} from "@/courses/services/ApiClientV2.js";
import {
  ASSIGNMENTS_API_V2_URLS,
  assignmentTypeListAPIUrl,
  assignmentProviderCSVImportUrl,
  assignmentProviderUploadUrl,
  ASSIGNMENT_TYPES_API_V2_URLS,
} from "@/courses/urls.js";

export const getAssignments = async (courseId, params = {}) => {
  const { data } = await apiClientV2.get(
    ASSIGNMENTS_API_V2_URLS.index.stringify({ courseId }),
    { params },
  );
  return data;
};

export const getAssignmentRequest = async (courseId, assignmentId) => {
  const { data } = await apiClientV2.get(
    ASSIGNMENTS_API_V2_URLS.resource.stringify({
      courseId,
      assignmentId,
    }),
  );
  return data;
};

export const getAssignmentAnalyticsRequest = async (
  courseId,
  assignmentId,
  params = {},
) => {
  const { data } = await apiClientV2.get(
    ASSIGNMENTS_API_V2_URLS.analytics.stringify(
      {
        courseId,
        assignmentId,
      },
      { params },
    ),
  );
  return data;
};

export const getStudentsRequest = async (courseId, assignmentId, params) => {
  const { data } = await apiClientV2.get(
    ASSIGNMENTS_API_V2_URLS.students.stringify({
      courseId,
      assignmentId,
    }),
    { params },
  );
  return data;
};

export const getGroupsRequest = async (courseId, assignmentId, params) => {
  const { data } = await apiClientV2.get(
    ASSIGNMENTS_API_V2_URLS.groups.stringify({
      courseId,
      assignmentId,
    }),
    { params },
  );
  return data;
};

export const deleteAllGradesRequest = (courseId, assignmentId, params) => {
  return apiClientV2.delete(
    ASSIGNMENTS_API_V2_URLS.deleteAllGrades.stringify({
      courseId,
      assignmentId,
    }),
    { params },
  );
};

export const releaseGradesRequest = (courseId, assignmentId, gradeIds) => {
  return apiClientV2.put(
    ASSIGNMENTS_API_V2_URLS.releaseGrades.stringify({
      courseId,
      assignmentId,
    }),
    { gradeIds },
  );
};

export const getAssignmentOptions = async ({
  courseId,
  exclude_id,
  exclude_student_logged,
}) => {
  const url = ASSIGNMENTS_API_V2_URLS.options.stringify({ courseId });
  const { data } = await apiClientV2.get(url, {
    params: { exclude_id, exclude_student_logged },
  });
  return data;
};

export const getAssignmentTypes = async () => {
  const url = assignmentTypeListAPIUrl.stringify();
  const { data } = await apiClient.get(url);
  return data.data
    .map((row) => row.attributes)
    .sort((a, b) => a.name.localeCompare(b.name));
};

export const getAssignmentSettings = async ({ courseId }) => {
  const url = ASSIGNMENT_TYPES_API_V2_URLS.settings.stringify({ courseId });
  const { data } = await apiClientV2.get(url);
  return data;
};

export const getAssignmentTypeRequest = async (courseId, assignmentTypeId) => {
  const url = ASSIGNMENT_TYPES_API_V2_URLS.resource.stringify({
    courseId: courseId,
    assignmentTypeId: assignmentTypeId,
  });
  const { data } = await apiClientV2.get(url);
  return data;
};

export const getAssignmentTypeOptions = async (courseId) => {
  const url = ASSIGNMENT_TYPES_API_V2_URLS.options.stringify({
    courseId: courseId,
  });
  const { data } = await apiClientV2.get(url);
  return data;
};

export const uploadAssignmentCSV = async (courseId, formData) => {
  const url = assignmentProviderUploadUrl.stringify({
    courseId,
    providerName: "csv",
  });
  const { data } = await formDataAPIClient.post(url, formData);
  return data.data.map((row) => row.attributes);
};

export const importAssignmentsFromCSV = async (courseId, assignments) => {
  const url = assignmentProviderCSVImportUrl.stringify({
    courseId,
    providerName: "csv",
  });
  const { data } = await apiClientV2.post(url, {
    assignments: { assignment_attributes: assignments },
  });
  return data;
};

export const createAssignment = async (courseId, formData) => {
  const url = ASSIGNMENTS_API_V2_URLS.index.stringify({ courseId });
  const { data } = await apiClientV2.post(url, formData);
  return data;
};

export const updateAssignment = async (courseId, assignmentId, formData) => {
  const url = ASSIGNMENTS_API_V2_URLS.resource.stringify({
    courseId,
    assignmentId,
  });
  const { data } = await apiClientV2.putForm(url, formData);
  return data;
};

export const deleteAssignmentRequest = async (courseId, assignmentId) => {
  const url = ASSIGNMENTS_API_V2_URLS.resource.stringify({
    courseId,
    assignmentId,
  });
  return apiClientV2.delete(url);
};
export const deleteAllAttendanceRequest = async (courseId) => {
  const url = ASSIGNMENTS_API_V2_URLS.deleteAllAttendance.stringify({
    courseId,
  });
  return apiClientV2.delete(url);
};
